// extracted by mini-css-extract-plugin
export default {"arrow":"ScrollToTop_arrow__rO7jJ","arrowActive":"ScrollToTop_arrowActive__6gZEL"};